import React from "react";
import styled from "styled-components";
import { Divider, device } from "../styled";
import { Link } from "react-router-dom";

const Container = styled.div`
  margin-top: 50px;
  background-image: url("/artist-team.jpg");
  background-position: center;
  background-size: cover;
  height: 70vh;
  color: #fff;
  background-position-y: 41%;

  h1 {
    color: #fff;
    text-shadow: 2px 2px 20px #000;
    padding-top: 15px;
    margin: 0;
    text-align: center;

    @media ${device.tablet} {
      font-size: 2.5em;
    }
  }

  @media ${device.tablet} {
    max-width: 1200px;
    margin: 0 auto;
    height: 100svh;
    background-position-y: 20%;
  }
`;

const TextContainer = styled.div`
  margin: 40% auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #000;
  box-sizing: content-box;
  box-shadow: 2px 2px 30px #000;
  border: 2px #fff solid;
  border-radius: 10px;
  padding: 10px;
  width: 80%;
  transition: all 0.8s ease;

  @media ${device.tablet} {
    width: 60%;
    margin: 40% auto;
  }

  @media ${device.desktop} {
    margin: 35% auto;
  }
`;
const MainTitle = styled.p`
  text-align: center;
  margin-top: 5px;
  margin-bottom: 10px;
  font-weight: bold;
  font-size: 1.5em;

  @media ${device.tablet} {
    font-size: 1.8em;
  }
`;
const SubDescription = styled.p`
  text-align: center;
  padding: 0 10px;
  font-size: 1.1em;

  @media ${device.tablet} {
    font-size: 1.2em;
  }
`;
const CtaText = styled.p`
  margin-top: 5px;
  font-size: 1.1em;
  text-align: center;

  @media ${device.tablet} {
    font-size: 1.2em;
  }
  a {
    span {
      color: #008080;
      font-weight: bold;
      text-decoration: underline;
    }
  }
`;

const WorkWithUs = () => {
  return (
    <Container>
      <h1>Legyél ARTIST barber</h1>
      <TextContainer>
        <MainTitle>Csatlakozz Te is Hozzánk!</MainTitle>
        <Divider />
        <SubDescription>
          Légy Te is része a mi történetünknek - jelentkezz most és emeld új
          szintre karriered velünk!
        </SubDescription>
        <CtaText>
          <Link to={"/carrier"}>
            <span>Kattints ide</span>
          </Link>
          <span> és ismerd meg a lehetőségeket!</span>
        </CtaText>
      </TextContainer>
    </Container>
  );
};

export default WorkWithUs;
